import StatsResponse from './StatsResponse';
import Channels from './Channels';
import AuthStore from './Auth'

class RootStore {
    constructor() {
        this.channelStats = new StatsResponse(this);
        this.channels = new Channels(this);
        this.auth = new AuthStore(this);
    }
}

const store = new RootStore();

export default store;



// WEBPACK FOOTER //
// ./src/app/models/store.js